module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"nightMode":"Night theme"}}')
  delete Component.options._Ctor
}
